module.exports = __webpack_public_path__ + "media/images/camarisol-85d1b874224e6e3d1fa10e507c7af0e2.png";